export enum ShopilinkItemType{
  PRODUCT = 'Product',
  SERVICE = 'Service'
}
